import React from "react"

import TokenList from "decentraland-gatsby/dist/utils/dom/TokenList"

import "./Twitter.css"

export type TwitterProps = React.SVGAttributes<SVGElement>

export const Twitter = React.memo(function (props: TwitterProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 72 72"
      className={TokenList.join(["icon-twitter", props.className])}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M42.5,31.2L66,6h-6L39.8,27.6L24,6H4l24.6,33.6L4,66
			h6l21.3-22.8L48,66h20L42.5,31.2z M12.9,10h8l38.1,52h-8L12.9,10z"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
})
